module.exports = __webpack_public_path__ + "img/annuity_start_age.6930b3b.svg";